import { Chart as ChartJS, ArcElement, Tooltip, Legend, Title } from "chart.js";
import { Doughnut } from "react-chartjs-2";
ChartJS.register(ArcElement, Tooltip, Legend, Title);

const DonutChart = ({ data, options }) => {
  const chartColors = {
    MEMBER: "hsl(248, 100.00%, 75.10%)",
    "FEE PAYER": "#5e569b",
    "NON MEMBER": "#d0d3d4",
    RETIREE: "#363445",
    "RETIREE MEMBER": "#48446e",
    "ASSOCIATE MEMBER": "rgb(22, 82, 146)",
    ASSOCIATE: "rgb(44, 119, 200)",
    OBJECTOR: "#ecf0f1",
  };
  // data = [
  //   { label: "Member", value: 150 },
  //   { label: "Non Member", value: 20 },
  //   { label: "Associate", value: 5 },
  //   { label: "Retiree", value: 40 },
  //   { label: "Fee Payer", value: 90 },
  //   { label: "Retiree Member", value: 20 },
  //   { label: "Associate Member", value: 20 },
  //   { label: "Objector", value: 20 },
  // ];

  const chartData = {
    labels: data.map((item) => `${item.label}: ${item.value}`),
    datasets: [
      {
        data: data.map((item) => item.value),
        backgroundColor: data.map((item) => chartColors[item.label]),
        borderColor: "white",
        borderWidth: 1,
      },
    ],
  };
  return (
    <div
      style={{
        width: "450px",
        height: "450px",
      }}
    >
      <Doughnut data={chartData} options={options} />
    </div>
  );
};

export default DonutChart;
